export function setValueToLocalStorage<T>(label: string, value?: T): void {
  const stringifyValue = JSON.stringify(value);

  localStorage.setItem(label, stringifyValue);
}
